import { useLocation, useNavigate } from "@tanstack/react-router";

import { useInvoiceBrowser } from "@/providers/invoice-browser";
import { useTenant } from "@/providers/session";
import type { Table } from "@tanstack/react-table";
import { useCallback } from "react";

export const useNavigateToInvoiceWithBrowsingQueue = (table: Table<any>) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { companySlug } = useTenant();
  const { setInvoiceBrowsingQueue } = useInvoiceBrowser();

  const navigateToInvoice = useCallback(
    (invoiceId: string) => {
      const ids = table
        .getSortedRowModel()
        .rows.map((row) => row.original.invoice.invoiceId);

      setInvoiceBrowsingQueue(ids as string[], invoiceId);

      const currentView = location.pathname.includes("buchhaltung")
        ? "buchhaltung"
        : "unternehmen";

      navigate({
        to: `/$company/${currentView}/rechnung/$id`,
        params: {
          company: companySlug,
          id: invoiceId,
        },
      });
    },
    [table, navigate, companySlug, location.pathname],
  );

  return navigateToInvoice;
};
